import React, { useState, useEffect } from "react";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../../../../services/api/API";
import Loader from "../../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";

const EditRole = () => {
  const [formData, setFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const navigate = useNavigate();
  const location=useLocation();
  const { data } = location.state || {};
  const BUSINESSPARTNERID= location?.state?.data?.business_partner_id
  console.log("bpid",BUSINESSPARTNERID);
  
  const authToken = localStorage.getItem("authToken");
  const [ userTypedd, setUserTypedd ] = useState([])
  const userType = localStorage.getItem("UserType")
  const businessPartnerId = localStorage.getItem("business_partner_id")
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    userTypedropdown()
  },[])

  const userTypedropdown = async () => {
    try{
      const response = await axiosInstance.get("/bp-onboard/bplist",{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      })

      const data = response.data.data.data
      const userTypeOptions = data.map(user => ({
        value: user.onboard_id,
        label:user.bp_name,
      }))
      setUserTypedd(userTypeOptions)
    }catch(error) {
      console.log(error)
    }
  }

  useEffect(() => {
    fetchRoleDetails();
  }, []);

  const fetchRoleDetails = async () => {
    try {
      setLoading(true)
      const response = await axiosInstance.get(`/role/edit/${data.role_id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      const fetchedData = response.data.data;
      console.log("fetchedData",fetchedData);
      setFormData({
        business_partner_id:fetchedData.business_partner_id,
        roleName: fetchedData.role_name,
        description: fetchedData.role_desc,
        status: fetchedData.status,
      });
    } catch (error) {
      console.error("Error fetching role details:", error);
    }
    finally{
      setLoading(false)
    }
  };

  const handleSubmit = async () => {
    const errors = {};
    let isValid = true;
  
    RoleInputs.forEach((field) => {
      if (field.validation) {
        if (field.name === "status" && formData.status === 0) {
          // Skip validation for status if it's 0
        } else if (field.validation.required && !formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });
  
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
  
    // Show confirmation alert before proceeding
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update this role?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          const payload = {
            role_name: formData.roleName,
            role_desc: formData.description,
            status: formData.status,
          };
  
          if (userType === "superadmin") {
            payload.business_partner_id = formData.business_partner_id;
          } else {
            payload.business_partner_id = businessPartnerId;
          }
  
          await axiosInstance.patch(
            `/role/update/${data.role_id}`,
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              }
            }
          );
  
          // Success alert after role is updated
          Swal.fire({
            title: "Success",
            text: "Role updated successfully.",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            navigate(ROUTES_NAVIGATION.ROLELIST); // Navigate after user clicks OK
          });
  
        } catch (error) {
          const errorMessage =
            error.response?.data?.message || "Failed to update role. Please try again.";
  
          // Error alert if role update fails
          Swal.fire({
            title: "Error",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
  
          console.error("Error updating role:", error);
        } finally {
          setLoading(false);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // User cancelled the update
        Swal.fire({
          title: "Cancelled",
          text: "Role update cancelled.",
          icon: "info",
          confirmButtonText: "OK",
        });
      }
    });
  };
  

  const RoleInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
            validation:{required:true}
            
          },
        ]
      : []),
      {
        name: "roleName",
        label: "Role Name",
        type: "text",
        required: true,
        gridClass: "col-lg-4",
        validation: {
          required: true,
          pattern: /^[A-Za-z\s]*$/,
          message: "Only alphabets and digits are allowed*",
        },
      },
  
    {
      name: "description",
      label: "Description",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { label: "Active", value: 1},
        { label: "Inactive", value: 0 },
      ],
      validation: { required: true },
      gridClass: "col-lg-4",
    },
  ];

  return (
  
      <div>
    {loading ? (
      <Loader />
    ) : (
      <><div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
            <img src={backicon} alt="back" />
            <span className="backbtntitle">Edit Role</span>
          </div><div className="form-container">
              <span className="cust-det-title mt-2 mb-2">Edit Role Details</span>
              <DynamicForm
                formConfig={RoleInputs}
                formData={formData}
                setFormData={setFormData}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors} />
            </div><div className="btncontainer mt-3">
              <button onClick={handleSubmit} className="submit-btn" disabled={loading}>
                Update
              </button>
            </div></>
       )}
    </div>
  
  );
};

export default EditRole;
